import { ContactEventStyle } from './ContactEvent.style'
import { ContactHistoryStyle } from './ContactHistory.style'
import { ContactItemStyle } from './ContactItem.style'
import { ContactItemsStyle } from './ContactItems.style'
import { ContactsDetailViewStyle } from './ContactsDetailView.style'
import { ContactsListEmptyNoticeStyle } from './ContactsListEmptyNotice.style'
import { ContactsListItemStyle } from './ContactsListItem.style'
import { ContactsListViewStyle } from './ContactsListView.style'
import { ContactSourceStyle } from './ContactSource.style'

export const contactsComponentStyles = {
  components: {
    ContactEventStyle,
    ContactHistoryStyle,
    ContactsDetailViewStyle,
    ContactItemStyle,
    ContactItemsStyle,
    ContactsListItemStyle,
    ContactsListViewStyle,
    ContactSourceStyle,
    ContactsListEmptyNoticeStyle,
  },
}
